export enum EnumTipoUso {
  GAS_USO_1_09 = 1,
  GAS_USO_1_10_1_COGENERACION,
  GAS_USO_1_10_2_COGENERACION,
  GAS_USO_1_10_1_NO_CARBURANTES,
  GAS_USO_1_10_2_PROFESIONAL,
  PWR_USO_Ind,
  PWR_USO_Otros,
  PWR_USO_05_85,
  PWR_USO_85_SL,
  GAS_USO_1_10_1_CICLO_COMBINADO,
  GAS_USO_1_10_1_CENTRAL_TERMICA,
  PWR_USO_100,
  PWR_USO_Exc_SL,
  PWR_USO_1_85
}
